import { mdiClose, mdiHistory, mdiPencil } from '@mdi/js';
import { Box, Typography, Badge, Tooltip, IconButton, Drawer, List, ListItemAvatar, ListItem, ListItemText, Divider, Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import React, { useMemo } from 'react';
import { MdiIcon } from '../MdiIcon';
import { StateChangeDialog } from './state';
const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end'
}));
export function HistoryTimeline({ atual = 0, historico = [], estados = [], onEstadoChange }) {
    const [open, setOpen] = React.useState(false);
    const [dialog, setDialog] = React.useState(false);
    const lista = useMemo(() => [...historico].sort((a, b) => {
        const cmp = moment(b.data).valueOf() - moment(a.data).valueOf();
        return cmp !== 0 ? cmp : b.id - a.id;
    }), [historico]);
    const estado = useMemo(() => estados.find((r) => r.id === atual)?.label, [estados, atual]);
    function stringToColor(string) {
        let hash = 0;
        let i;
        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color = '#';
        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */
        return color;
    }
    function stringAvatar(name) {
        const parts = name.trim().split(/\s+/);
        const initials = (parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '');
        return {
            sx: { bgcolor: stringToColor(name) },
            children: initials.toUpperCase(),
        };
    }
    // useEffect(() => {
    //   const h = historico.sort((a, b) => {
    //     const cmp = moment(b.data).valueOf() - moment(a.data).valueOf();
    //     if (cmp !== 0) return cmp;
    //     return b.id - a.id;
    //   });
    //   setLista(h);
    //   const c = estados.find(r => r.id === atual);
    //   if (c) {
    //     setEstado(c.label);
    //   }
    // }, [atual, estados, historico]);
    return (<React.Fragment>
      <StateChangeDialog open={dialog} title='Alterar estado' atual={atual} lista={estados} onClose={data => {
            if (data) {
                onEstadoChange(data.id, data.observacoes);
            }
            setDialog(false);
        }}/>
      <Drawer PaperProps={{
            sx: { width: '520px', transform: 'scale(0.9)' }
        }} variant='temporary' anchor='right' open={open}>
        <DrawerHeader>
          <IconButton onClick={() => {
            setOpen(false);
        }}>
            <MdiIcon path={mdiClose} size={1}/>
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {lista.length > 0 &&
            lista.map((r, i) => {
                return (<ListItem key={`drawer-li-${r.id}`}>
                  <ListItemAvatar>
                    <Avatar {...stringAvatar(r.user)}/>
                  </ListItemAvatar>
                  <ListItemText primary={r.estado} secondary={<>
                        <Typography component='span' variant='body2' color='textSecondary'>
                          {r.user}, {moment(r.data).format('DD/MM/YYYY [às] HH:mm')}
                        </Typography>
                        {r.observacoes ? (<>
                            <br />
                            <Typography component='span' variant='caption' color='textSecondary'>
                              Observações: {r.observacoes}
                            </Typography>
                          </>) : (<></>)}
                      </>}></ListItemText>
                </ListItem>);
            })}
          {lista.length === 0 && (<ListItem>
              <ListItemText primary='Sem histórico!'/>
            </ListItem>)}
        </List>
      </Drawer>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box>
          {estado ? estado : 'Sem estado'}
          {lista.length > 0 && (<>
              <Typography variant='caption' gutterBottom sx={{ display: 'block' }}>
                {lista.at(0).user}, {moment(lista.at(0).data).format('DD/MM/YYYY [às] HH:mm')}
              </Typography>
              {lista.at(0).observacoes && (<Typography variant='caption' color='textSecondary' gutterBottom sx={{ display: 'block' }}>
                  Observações: {lista.at(0).observacoes}
                </Typography>)}
            </>)}
        </Box>

        <Box sx={{ ml: 1 }}>
          <Badge color='primary' badgeContent={lista.length}>
            <Tooltip title='Histórico de alterações'>
              <IconButton onClick={() => {
            setOpen(true);
        }}>
                <MdiIcon path={mdiHistory} size={0.7}/>
              </IconButton>
            </Tooltip>
          </Badge>
          <Tooltip title='Alterar estado'>
            <IconButton onClick={() => {
            setDialog(true);
        }}>
              <MdiIcon path={mdiPencil} size={0.7}/>
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </React.Fragment>);
}
